import React, { useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import '../../../assets/stylesheets/ClubSlide/PokerFrame.scss'
import { getPokerFrames } from '../../../store/selectors';
import { initPokerFrame } from '../../../store/actionCreators/club';

const PokerFrame = ({ club }) => {
    const dispatch = useDispatch();
    const pokerWindows = useSelector(getPokerFrames);
    const frameName = `pokerClient_${club.clubId}`;

    useEffect(() => {
        if (!!club.clubId) {
            dispatch(initPokerFrame(club.clubId));
        }
    }, [club]);

    return (
        <div className={`pokerFrame ${pokerWindows[club.clubId] && pokerWindows[club.clubId].isVisible ? 'visible' : ''}`}>
            { pokerWindows[club.clubId] && !pokerWindows[club.clubId].closed &&
                <iframe allowFullScreen name={frameName} />
            }
        </div>
    )
};

export default PokerFrame;
